export const ApiRuntimeMode = {
  Real: 'real',
  Mock: 'mock',
} as const;

export type ApiRuntimeMode = (typeof ApiRuntimeMode)[keyof typeof ApiRuntimeMode];
